import { capitaliseString, generateMappingKey } from "helpers/GeneralHelpers";
import { Button } from "react-bootstrap";

const OrganisationTagsComponent = ({ title, tags, onSelected }) => {
  return (
    <div className="flex flex-row gap-5 items-center">
      <label className="text-label-2">{title}</label>
      <div className="flex flex-row gap-3 items-center">
        {tags?.map((tag) => {
          return (
            <Button
              key={generateMappingKey(tag)}
              variant="tag"
              onClick={(e) => {
                e.preventDefault();
                onSelected(tag);
              }}
            >
              {capitaliseString(tag)}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default OrganisationTagsComponent;
